<script setup lang="ts">
  import type { PrimitiveProps } from 'reka-ui';
  import { Primitive } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import type { ButtonVariants } from '.';
  import { buttonVariants } from '.';

  export interface Props extends PrimitiveProps {
    as?: string;
    class?: HTMLAttributes['class'];
    disabled?: boolean;
    loading?: boolean;
    size?: ButtonVariants['size'];
    variant?: ButtonVariants['variant'];
  }

  const props = withDefaults(defineProps<Props>(), {
    as: 'button',
    disabled: false,
  });
</script>

<template>
  <Primitive
    data-slot="button"
    :as="as"
    :as-child="asChild"
    :class="cn('s-btn cursor-pointer', buttonVariants({ variant, size }), props.class)"
    :disabled="disabled || loading"
    :data-loading="loading ? 'loading' : ''"
  >
    <i v-if="loading" class="fa fa-spinner-third animate-spin absolute ml-auto loading-spinner" />

    <slot />
  </Primitive>
</template>

<style scoped lang="postcss">
  .s-btn[data-loading='loading'] {
    color: transparent;
  }

  .s-btn[data-loading='loading'] > *:not(.loading-spinner) {
    visibility: hidden;
    color: transparent;
  }
</style>
